import React, { useState } from "react";
import AccessConnection from "./AccessConnection";
import AccessEndPoint from "./AccessEndPoint";
import AccessProjectEndPoint from "./AccessProjectEndPoint";
import ProjectRequest from "./ProjectRequest";
import AppCategory from "./AppCategory";
import AppSubCategory from "./AppSubCategory.jsx";
import AppGroup from "./AppGroup";
import SecurityEvent from "./SecurityEvent";
import AccessSection from "./AccessSection";


const AccessManager = () => {
  const [activeComponent, setActiveComponent] = useState("App Category");

  const renderComponent = () => {
    switch (activeComponent) {
      case "App Category":
        return <AppCategory />;
      case "App Sub Category":
        return <AppSubCategory />;
      case "App Group":
        return <AppGroup />;
      case "Access Connection":
        return <AccessConnection />;
      case "Access End Point":
        return <AccessEndPoint />;
      case "Access Project End Point":
        return <AccessProjectEndPoint />;
      case "Project Settings":
        return <AccessSection />;

      case "Project Request":
        return <ProjectRequest />;
      case "Security Event":
        return <SecurityEvent />;       
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)] z-20">
      <h1 className="text-xl m-4 font-semibold">Application Access Manager</h1>
      <div className="flex mb-6 flex-wrap gap-2">
        {[
          "App Category",
          "App Sub Category",
          "App Group",
          "Access Connection",
          "Access End Point",
          "Access Project End Point",
          "Project Request",
          "Security Event",
          "Project Settings",
        ].map((name) => (
          <button
            key={name}
            className={`px-2 py-2 rounded-lg text-sm border-b-2 min-w-42 ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => setActiveComponent(name)}
          >
            {name}
          </button>
        ))}
      </div>
       </div>

      {renderComponent()}
    </div>
  );
};

export default AccessManager;
